import ObjectPropField from './_object_input/ObjectPropField';

export default function ObjectInput({ ancestors = [], component, value, object_schema }) {
  if (!object_schema) {
    return <div>No object_schema was found.</div>;
  }

  return (
    <div className="dp-object">
      {object_schema.map((os, index) => (
        <ObjectPropField
          key={index}
          {...{
            // Pass the ancestors down, which is the path to this object
            ancestors,
            component,
            // Pass the entire object's value down
            value,
            ...os,
          }}
        />
      ))}
    </div>
  );
}
